import { catchError, tap, switchMap, map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { AuthenticationService } from '../authentication/authentication.service';
import { ConfigService } from '@app/core/config.service';
import { COOKIES, ENDPOINTS, DEFAULT_APP_VALUES, AFFILIATION_TYPES } from '@app/app.constants';
import * as i0 from "@angular/core";
import * as i1 from "../authentication/authentication.service";
import * as i2 from "../../config.service";
import * as i3 from "ngx-cookie-service/cookie-service/cookie.service";
import * as i4 from "@angular/common/http";
var ProfileService = /** @class */ (function () {
    function ProfileService(authenticationService, configService, cookieService, httpClient) {
        this.authenticationService = authenticationService;
        this.configService = configService;
        this.cookieService = cookieService;
        this.httpClient = httpClient;
        this.cookies = COOKIES;
        this.webApiUrl = this.configService.getValue('webApiUrl');
    }
    /**
     * Returns list of affiliations (e.g. PASSHOLDER, FL_RESIDENT etc)
     * @returns Observable of Affiliations
     */
    ProfileService.prototype.getAffiliations = function () {
        var _this = this;
        return this.authenticationService.isLoggedIn().pipe(switchMap(function (isLogged) {
            if (isLogged) {
                if (_this.affiliations) {
                    return of(_this.affiliations);
                }
                else {
                    var SWID = _this.cookieService.get(COOKIES.SWID);
                    var affiliationsUrl = ("" + _this.webApiUrl + ENDPOINTS.affiliations).replace('{swid}', SWID);
                    return _this.httpClient.get(affiliationsUrl)
                        .pipe(map(function (response) {
                        var affiliations = [];
                        // Just only use ther first affiliation with affiliationType === CASTAWAYCLUB
                        var firstAffilliation = response.entries.find(function (entry) { return entry.affiliationType === AFFILIATION_TYPES.CASTAWAY; });
                        if (firstAffilliation) {
                            affiliations.push({
                                affiliationType: firstAffilliation.affiliationType,
                                affiliationLevel: firstAffilliation.affiliationLevel || firstAffilliation.level,
                                affiliationId: firstAffilliation.affiliationId || firstAffilliation.clubId
                            });
                        }
                        return affiliations;
                    }), tap(function (response) { return _this.affiliations = response; }), catchError(function () {
                        // TODO: The error handling for this http call should be updated
                        // when the specification for errors is defined
                        return of(DEFAULT_APP_VALUES.affiliations);
                    }));
                }
            }
            else {
                return of(DEFAULT_APP_VALUES.affiliations);
            }
        }));
    };
    ProfileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProfileService_Factory() { return new ProfileService(i0.ɵɵinject(i1.AuthenticationService), i0.ɵɵinject(i2.ConfigService), i0.ɵɵinject(i3.CookieService), i0.ɵɵinject(i4.HttpClient)); }, token: ProfileService, providedIn: "root" });
    return ProfileService;
}());
export { ProfileService };
